import Store from '@/store'

export function getCoordinates() {
    navigator.geolocation.getCurrentPosition((pos) => Store.dispatch('setGeolocation', pos.coords), (err) => console.warn('ERROR(' + err.code + '): ' + err.message), {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    });
}
